<span
  ui-dropdown
  class="ant-table-filter-trigger"
  uiTrigger="click"
  uiPlacement="bottomRight"
  [uiBackdrop]="nzBackdrop || nzHasBackdrop"
  [uiClickHide]="false"
  [uiDropdownMenu]="nzDropdownMenu"
  [class.active]="nzActive"
  [class.ant-table-filter-open]="nzVisible"
  [uiVisible]="nzVisible"
  (uiVisibleChange)="onVisibleChange($event)">
  <ng-content></ng-content>
</span>
